import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Company, Manager } from '@shared/models';
import { Pagination } from '@shared/pagination';

import { CompanyAutoOptionAdapter } from './../models/company';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CompanyService extends ApiService<Company> {
  filteredCompanies$: Observable<Company[]>;
  filteredOptions$: Observable<any[]>; // TODO: create better type
  private filteredCompaniesSubject = new Subject<string>();

  constructor(http: HttpClient) {
    super(http);
    this.url = 'company/';

    this.filteredCompanies$ = this.filteredCompaniesSubject.pipe(
      switchMap((name: string) =>
        name !== null && name.length > 2
          ? this.getFilterCompanies(name).pipe(map((pagination) => pagination.content))
          : of([]),
      ),
    );

    this.filteredOptions$ = this.filteredCompanies$.pipe(
      map((companies: Company[]) =>
        companies.map((company: Company) => CompanyAutoOptionAdapter.toOption(company)),
      ),
    );
  }

  filter(name: string): void {
    this.filteredCompaniesSubject.next(name);
  }

  getFilterCompanies(
    filterText: string,
    size = 20,
    page: number = 0,
    sortDir: string = 'asc',
  ): Observable<Pagination<Company>> {
    return this.get({
      url: 'autocomplete',
      params: {
        name: filterText,
        size,
        page,
        ['sort.dir']: sortDir,
      },
    });
  }

  getManagersForCompany(id: number, offset: number): Observable<Pagination<Manager>> {
    return this.get({
      url: `${id}/managers`,
      params: { offset },
    });
  }
}
